import React from 'react'
import { Route, Routes } from 'react-router-dom'
import LoginPage from './pages/LoginPage'
import Layout from './utils/Layout'
import Overview from './pages/Overview'
import Products from './pages/Products'
import Categories from './pages/Categories'
import PrivateRoute from './utils/PrivateRoute'
import Customers from './pages/Customers'
import Orders from './pages/Orders'
import Transactions from './pages/Transactions'
import Blogs from './pages/Blogs'
import BlogDetail from './pages/BlogDetail'

const App = () => {
  return (


    <Routes>
      <Route path='/' element={<LoginPage />} />
      <Route element={<PrivateRoute />}>
        <Route path='/dashboard' element={<Layout />}>
          <Route index element={<Overview />} />
          <Route path='products' element={<Products />} />
          <Route path='categories' element={<Categories />} />
          <Route path='customers' element={<Customers />} />
          <Route path='orders' element={<Orders />} />
          <Route path='transactions' element={<Transactions />} />
          <Route path='blogs' element={<Blogs />} />
          <Route path='blog/:id' element={<BlogDetail />} />



        </Route>
      </Route>
    </Routes>
  )
}

export default App